<script>
import { MdsButton } from "@mds/button";
import MdsSelect from "@mds/select";
import MdsFieldset from "@mds/fieldset";
import AdlRangeSlider from "../range-slider/RangeSlider.vue";
import AdlMultiplePopOver from "../multiple-pop-over/MultiplePopOver.vue";
import AdlSwitchIcon from "../switch-icon/SwitchIcon.vue";
import MdsSwitch from "@mds/switch";
import MdsCheckbox from "@mds/checkbox";
import AdlDataList from "../DataList/DataList.vue";
export default {
  props: {
    groupElement: {
      type: Array,
    },
    elements: {
      type: Array,
      required: true,
    },
    isInline: {
      type: Boolean,
    },
    addDefaultMargin: {
      type: Boolean,
    },
    relativePosition: {
      type: Boolean,
    },
    groupId: {
      type: String,
    },
  },
  computed: {
    classObject() {
      const obj = {};
      obj[this.$style["expandableEloqua-form--margin"]] = this.addDefaultMargin;
      obj[this.$style["expandableEloqua-form--inline"]] = this.isInline;
      obj[this.$style["expandableEloqua-form--relativePosition"]] =
        this.relativePosition;

      return obj;
    },
  },
  data() {
    return {
      formElements: this.getFormElements(),
    };
  },
  components: {
    MdsButton,
    MdsSelect,
    MdsFieldset,
    AdlRangeSlider,
    MdsSwitch,
    AdlSwitchIcon,
    AdlMultiplePopOver,
    MdsCheckbox,
    AdlDataList,
  },
  methods: {
    getFormElements() {
      let elements = [];
      for (let i = 0; i < this.groupElement.length; i++) {
        elements.push(this.elements[this.groupElement[i]]);
      }
      return elements;
    },
    EditDetails(data) {
      this.$emit("EditDataList", data);
    },
    inputChange() {
      this.$emit("formChange", this.groupId);
    },
    dropDownChange(callBackMethod, selectedValue, options) {
      let selectedObj = options.filter((sr) => sr.value == selectedValue);
      this.$emit(
        "dropDownChange",
        callBackMethod,
        selectedObj[0],
        this.groupId
      );
    },
  },
};
</script>

<template>
  <div :class="[$style['expandableEloqua-form'], classObject]">
    <template v-for="element in formElements">
      <adl-range-slider
        :data-id="element.id"
        v-if="element.displayType === 'slider' && !element.ishide"
        :options="element.options"
        :lower-label="element.name"
        :name="element.htmlName"
        :step="element.step"
        :isShowRefreshIcon="element.isShowRefreshIcon"
        :key="element.id"
        :required="element.isRequired"
        :min="element.minValue"
        :max="element.maxValue"
        :inputMax="element.inputMax"
        :isShowDecimal="element.isShowDecimal"
        :inputFormat="element.inputFormat"
        :isCurrencyFormat="element.isCurrencyFormat"
        :tooltipMessage="element.tooltipMessage"
        :refreshText="element.refreshText"
        :disabled="element.isdisabled"
        v-model="element.value"
        :maxlength="element.maxlength"
        @change="inputChange()"
      ></adl-range-slider>

      <mds-select
        :data-id="element.id"
        v-else-if="element.displayType === 'singleSelect'"
        :options="element.options"
        :label="element.name"
        :name="element.htmlName"
        :key="element.id"
        :required="element.isRequired"
        v-model="element.value"
        @change="
          dropDownChange(element.emitevent, element.value, element.options)
        "
      ></mds-select>
      <adl-data-list
        v-else-if="
          element.displayType === 'AdditionalInformation' &&
          element.options != null &&
          element.options.length > 0
        "
        :headingtext="element.name"
        :listdata="element.options"
        :editbuttonvisible="true"
        @OnEdit="EditDetails"
      >
      </adl-data-list>
      <adl-multiple-pop-over
        v-else-if="element.displayType === 'popover' && !element.ishide"
        :options="element.options"
        :label="element.name"
        :name="element.htmlName"
        v-model="element.value"
        @change="inputChange()"
      ></adl-multiple-pop-over>
      <adl-switch-icon
        v-else-if="element.displayType === 'switchIcon'"
        :data-id="element.id"
        :label="element.name"
        :text="element.text"
        :name="element.htmlName"
        :key="element.id"
        :position="element.position"
        :tooltipMessage="element.tooltipMessage"
        v-model="element.value"
        @change="inputChange()"
      >
        <template v-if="$slots.tooltipText" v-slot:tooltipText>
          <slot name="tooltipText"></slot>
        </template>
      </adl-switch-icon>

      <mds-checkbox
        v-else-if="element.displayType === 'checkbox' && !element.ishide"
        v-model="element.value"
        @change.native="inputChange()"
        >{{ element.name }}</mds-checkbox
      >
    </template>
  </div>
</template>

<style module lang="scss">
@import "@mds/constants";
@import "@mds/typography";
@import "@mds/link";

.expandableEloqua-form--margin {
  margin-top: $mds-space-2-x;
}
.expandableEloqua-form--inline {
  display: flex;
}
.expandableEloqua-form--right {
  position: absolute;
  right: 0px;
  margin-right: $mds-space-3-x;
}
.expandableEloqua-form--relativePosition {
  position: relative;
}
</style>
